import "./inverterConfig.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import { useSelector } from "react-redux";
import { inverterInformation } from "../../DataFiles/inverterInformation";
import OneLineDiagram from "./oneLineDiagram";

const InverterConfig = (props) => {
  const { tableContent, index, inverterInfo } = props;
  const pageDetail = tableContent.find(
    (item) => item.title === "Inverter Configuration"
  );
  const roofInfo = useSelector((state) => state.roof);
  const oneLineDiagram = useSelector((state) => state.img.inverterImage);
  const quantityInfo = useSelector((state) => state.quantity);
  const roofData = quantityInfo?.roofData || [];
  const roofIndex = index;
  const check = quantityInfo.allRoof;
  const roofDetail = roofData[roofIndex];

  let totalCapacity = 0;
  let pvModule = 0;
  let mountingStructure = "";
  let noOfMountingStructure = 0;
  let tiltAngle = 15;
  let Azimuth = 180;
  let structureFacing = "Azimuth Facing";

  if (check && quantityInfo.electricalConfiguration === "All Roof") {
    mountingStructure = "Multiple Structure";
    noOfMountingStructure = "";
    for (let i = 0; i < roofData.length; i++) {
      const element = roofData[i];
      if (element.structureType === "Single") {
        totalCapacity += Number(element.totalKilowatt);
        pvModule += element.pvModule;
      } else {
        const totalKilowatt = Number(
          roofDetail.multipleStructure
            .reduce((total, data) => total + data.totalKilowatt, 0)
            .toFixed(1)
        );
        totalCapacity += Number(totalKilowatt);
        const noOfPanel = element.multipleStructure.reduce(
          (sum, value) => sum + value.pvModule,
          0
        );
        pvModule += noOfPanel;
      }
      if (i > 0) {
        tiltAngle += ", ";
      }
      if (element.roofType === "Shed Roof") {
        tiltAngle += element.buildingPitch;
      } else if (
        element.roofType === "Customized Roof" ||
        element.roofType === "Carport"
      ) {
        tiltAngle += 10;
      } else if (i !== 0) {
        tiltAngle += 15;
      }
    }
  } else {
    if (roofDetail.roofType === "Shed Roof") {
      tiltAngle = roofDetail.buildingPitch;
    } else if (
      roofDetail.roofType === "Customized Roof" ||
      roofDetail.roofType === "Carport"
    ) {
      tiltAngle = 10;
    }
    if (roofDetail.structureType === "Single") {
      totalCapacity += Number(roofDetail.totalKilowatt);
      pvModule = roofDetail.pvModule;
      mountingStructure = roofDetail.mountingStructure;
      noOfMountingStructure = roofDetail.totalStructure;
    } else {
      const totalKilowatt = Number(
        roofDetail.multipleStructure
          .reduce((total, data) => total + data.totalKilowatt, 0)
          .toFixed(1)
      );
      totalCapacity += Number(totalKilowatt);
      mountingStructure = "Multi-Structure";
      noOfMountingStructure = roofDetail.multipleStructure
        .reduce((total, data) => total + parseFloat(data.totalStructure), 0)
        .toFixed(0);
      pvModule = roofDetail.multipleStructure.reduce(
        (sum, value) => sum + value.pvModule,
        0
      );
    }
  }

  const Manufacturer = inverterInfo?.inverterManufacturer
    ? inverterInfo.inverterManufacturer
    : "Select";

  let inverterBrand = inverterInformation.find(
    (item) =>
      item.brand === inverterInfo.inverterManufacturer &&
      item.phase === inverterInfo.inverterPhase &&
      item.systemType === inverterInfo.systemType
  );
  let inverterDetail =
    inverterInfo.inverterType !== "Select"
      ? inverterBrand.inverterType.find(
          (item) => item.name === inverterInfo.inverterType
        )
      : [];
  const ACDCRatio = Number(
    (
      Number(totalCapacity) /
      (Number(inverterDetail.value) * inverterInfo.noOfInverter)
    ).toFixed(2)
  );

  let inverterConfig = [
    {
      title: "Manufacturer",
      value: Manufacturer,
    },
    {
      title: "Number of inverters",
      value: inverterInfo.noOfInverter,
    },
    {
      title: "Sizing factor",
      value: `${ACDCRatio}%`,
    },
  ];

  let imageSrc = oneLineDiagram;

  if (!imageSrc) {
    imageSrc = roofInfo.electricalImageUrl;
  }

  function tableRender(tableData) {
    return (
      <div className="render-function">
        <table className="render-table">
          <thead>
            <tr>
              <td>Property</td>
              <td>Value</td>
            </tr>
          </thead>
          <tbody>
            {tableData.map((item, index) => {
              return (
                <tr key={index} className={index % 2 === 0 ? "one" : "two"}>
                  <td className="left">{item.title}</td>
                  <td className="right">{item.value}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  const title = check
    ? quantityInfo.electricalConfiguration === "All Roof"
      ? `Inverter Configuration (All Roof)`
      : `Inverter Configuration (Roof ${index + 1})`
    : `Inverter Configuration`;

  let value = "";
  if (inverterInfo.inverterType === "Select") {
    if (quantityInfo.electricalConfiguration === "All Roof") {
      value = "*Required all roof configuration";
    } else {
      value = "*Required single roof configuration";
    }
  }

  return (
    <div id="inverter-config" className="inverter-config">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header />
      {/* Main Body */}
      <main className="ic-body">
        <p>
          {title} <span>{value}</span>
        </p>
        <div className="data-tables">
          {/* PV Panel */}
          {tableRender(inverterConfig)}
        </div>

        <OneLineDiagram inverterInfo={inverterInfo}></OneLineDiagram>

        <div className="symbolBox">
          <div className="container">
            <div className="infoBox">
              <span>{pvModule} PV Modules</span>
              <span>{totalCapacity} KW System Size</span>
              <span>
                {Azimuth} {structureFacing}
              </span>
              <span>{tiltAngle} Tilt Angle</span>
              <span>
                {noOfMountingStructure} {mountingStructure}
              </span>
            </div>
            <div className="fixed">
              <span>House Connection</span>
              <img
                src="./images/electricalAssets/fixed.svg"
                alt="inverter"
              ></img>
            </div>
          </div>
          <div className="symbolInfo">
            <span>(1) Inverter</span>
            <img
              src="./images/electricalAssets/Inverter.svg"
              alt="inverter"
            ></img>
            <span>
              {inverterInfo.noOfInverter}x{inverterInfo.inverterManufacturer}
            </span>
            <span style={{ width: "95px", textAlign: "center" }}>
              {inverterInfo.inverterType}
            </span>
          </div>
          <div className="container">
            <div className="symbolInfo">
              <span>(2) PV Module</span>
              <img
                src="./images/electricalAssets//strings.jpg"
                alt="string"
              ></img>
              <span>
                {pvModule}x{roofDetail.module}
              </span>
              <span>{roofDetail.moduleType}</span>
            </div>
            <div className="stringDetail">
              <div className="stringBox">
                <img
                  src="./images/electricalAssets/strings.jpg"
                  alt="string"
                ></img>
                <div className="subLine">
                  <span>axb</span>
                  <span style={{ lineHeight: "1px" }}>-----------</span>
                </div>
                <img
                  src="./images/electricalAssets/strings.jpg"
                  alt="string"
                ></img>
              </div>
            </div>
          </div>
          <div className="container" style={{ marginTop: "-12px" }}>
            <div className="symbolInfo">
              <span>(3)Feed in Meter</span>
              <img
                src="./images/electricalAssets/feedMeter2.png"
                alt="inverter"
              ></img>
            </div>
            <div className="symbolInfo">
              <span>(4)Bidirectional Meter</span>
              <img
                src="./images/electricalAssets/feedMeter.svg"
                alt="inverter"
              ></img>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer
        pageNo={`${pageDetail ? pageDetail.pageNo : 12}/${
          tableContent[tableContent.length - 1].pageNo
        }`}
      />
    </div>
  );
};

export default InverterConfig;
